import type { SeparatorLegacy } from "../legacy/separator"
import { SeparatorContentSchema } from "../separator"
import type { SeparatorContent } from "../separator"
import type { LegacyContentCtx, LegacyCodec } from "./legacyContentCtx"

const SeparatorContentType = "SeparatorContent"

export const SeparatorLegacyCodec = (
	ctx: LegacyContentCtx,
): LegacyCodec<SeparatorContent, SeparatorLegacy> => ({
	name: "SeparatorLegacy",

	is(input): input is SeparatorContent {
		return SeparatorContentSchema.safeParse(input).success
	},

	toContent(_input) {
		return {
			success: true,
			data: {
				__TYPE__: SeparatorContentType,
			},
		}
	},

	fromContent() {
		return {
			content: {},
			types: { [ctx.keyOfType]: "Separator" },
			keys: {},
		}
	},
})
